import { render, staticRenderFns } from "./CompanySurveyExplanation.vue?vue&type=template&id=ffdbe5b2&scoped=true"
import script from "./CompanySurveyExplanation.vue?vue&type=script&lang=js"
export * from "./CompanySurveyExplanation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdbe5b2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxSectionText: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/SectionText.vue').default,IxSection: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/Section.vue').default})
